/*eslint-disable*/
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useClerk, useAuth } from "@clerk/clerk-react";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../Actions/authAction";
import {
  Layout,
  Menu,
  Avatar,
  Dropdown,
  Breadcrumb,
  Affix,
  Typography,
  Image,
  message,
} from "antd";
import {
  SettingOutlined,
  ApartmentOutlined,
  TeamOutlined,
  HomeOutlined,
  UserOutlined,
  DashboardOutlined,
  FullscreenExitOutlined,
  UserAddOutlined,
  InboxOutlined,
  ProjectOutlined,
  PropertySafetyOutlined,
  BoxPlotOutlined,
  ShopOutlined,
  FileTextOutlined,
  MailOutlined,
  CloudDownloadOutlined,
} from "@ant-design/icons";
import Dashboard from "../pages/Dashboard";
import Clients from "../pages/clients";
import Properties from "../pages/properties";
import Areas from "../pages/areas";
import Leads from "../pages/leads";
// The section is called "Cloud Leads"; the file keeps the API's pre_leads name.
import CloudLeads from "../pages/preLeads";
import Tasks from "../pages/tasks";
import InBoundProperties from "../pages/inboundProperty";
import EmployeeUsers from "../pages/employeeUsers";
import ResidentialProjects from "../pages/ResidentialProjects";
import CommercialProjects from "../pages/CommercialProjects";
import LandProjects from "../pages/LandProjects";
import RentResidentialProperties from "../pages/RentResidentialProperties";
import BunglowProperties from "../pages/BunglowProperties";
import FlatProperties from "../pages/FlatProperties";
import RentCommercialProperties from "../pages/RentCommercialProperties";
import CommercialProperties from "../pages/CommercialProperties";
import LandProperties from "../pages/LandProperties";
import Activity from "../pages/Activity";
import BunglowDeveloperProperties from "../pages/BunglowDeveloperProperties";
import FlatDeveloperProperties from "../pages/FlatDeveloperProperties";
import CommercialDevelporProperies from "../pages/CommercialDevelporProperies";
import LandDeveloperProperties from "../pages/LandDeveloperProperties";
import { ReactComponent as DeveloperIcon } from "../assets/images/developer.svg";
import { ReactComponent as BuilderIcon } from "../assets/images/builder.svg";
import { getCurrentUser } from "../Actions/usersAction";
import useResizeObserver from "./useResizeObserver";
import { debounce } from "lodash";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import Enquiries from "./Enquiries";
import AgricultureProperties from "../pages/AgricultureProperties";
import { PiFarmLight } from "react-icons/pi";
import { setTokenFetcher } from "../Utils/API";
import NotificationBell from "./NotificationBell";

const { Header, Content, Sider } = Layout;
export default (props) => {
  const { itemKeyValue } = props;
  const { isMobile, isTablet, isDesktop } = useBreakpoints();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const { currentUser } = useSelector((state) => {
    const { currentUser } = state.users;
    return { currentUser };
  });
  const [collapsed, setCollapsed] = useState(false);
  const { role } = currentUser;
  const { signOut } = useClerk();
  const { isSignedIn, isLoaded, getToken } = useAuth();
  const [token, setToken] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        setTokenFetcher(getToken);
        const result = await getToken();
        setToken(result);
      } catch (err) {
        console.error("Error fetching token in AppView:", err);
      }
    };

    if (isLoaded && isSignedIn) {
      fetchToken();
    }
  }, [isLoaded, isSignedIn, getToken]);

  const handleAuthFailure = async (err) => {
    message.error(
      "Access Denied: Your account is not registered in our database.",
    );
    localStorage.removeItem("access_token");
    dispatch(removeUser());
    await signOut({ redirectUrl: window.location.origin });
  };

  useEffect(() => {
    if (token) {
      dispatch(getCurrentUser(null, handleAuthFailure));
    }
  }, [token]);

  const handleLogout = async () => {
    localStorage.removeItem("access_token");
    dispatch(removeUser());
    await signOut({ redirectUrl: window.location.origin });
  };

  const [itemKey, setItemKey] = useState(itemKeyValue ? itemKeyValue : "1");
  const [size, setSize] = useState({ width: 0, height: 0 });
  // const menuItemAlign = { display: 'flex', alignItems: 'center', fontSize: 18 };

  const items = [
    {
      key: "1",
      label: <Typography onClick={handleLogout}>Logout</Typography>,
    },
  ];
  const { SubMenu } = Menu;
  const menuItems = [
    {
      label: "Dashboard",
      key: "1",
      icon: <DashboardOutlined />,
    },
    {
      label: "Clients",
      key: "2",
      icon: <TeamOutlined />,
    },
    {
      label: "Developers",
      key: "23",
      icon: <DeveloperIcon />,
    },
    {
      label: "Properties",
      key: "3",
      icon: <PropertySafetyOutlined />,
      children: [
        {
          label: "Bunglow",
          key: "4",
          icon: <HomeOutlined />,
        },
        {
          label: "Flat",
          key: "5",
          icon: <ShopOutlined />,
        },
        {
          label: "Rent Residential",
          key: "6",
          icon: <HomeOutlined />,
        },
        {
          label: "Commercial",
          key: "7",
          icon: <ShopOutlined />,
        },
        {
          label: "Rent Commercial",
          key: "8",
          icon: <HomeOutlined />,
        },
        {
          label: "Land",
          key: "9",
          icon: <BoxPlotOutlined />,
          role: "Admin",
        },
        {
          label: "NA/Agriculture",
          key: "25",
          icon: <PiFarmLight size={16} />,
        },
      ],
    },
    {
      label: "Builder",
      key: "18",
      icon: <BuilderIcon />,

      children: [
        {
          label: "Bunglow",
          key: "19",
          icon: <HomeOutlined />,
        },
        {
          label: "Flat",
          key: "20",
          icon: <ShopOutlined />,
        },

        {
          label: "Commercial",
          key: "21",
          icon: <ShopOutlined />,
        },

        {
          label: "Land",
          key: "22",
          icon: <BoxPlotOutlined />,
          role: "Admin",
        },
      ],
    },
    {
      label: "Leads",
      key: "10",
      icon: <ApartmentOutlined />,
    },
    {
      // Cloud Leads deliberately does not use the UserPermission system - every
      // authenticated user gets the section and the backend scopes the rows to
      // what they are assigned. Only the admin-only controls inside are gated.
      label: "Cloud Leads",
      key: "26",
      icon: <CloudDownloadOutlined />,
    },
    {
      label: "Projects",
      key: "11.1",
      icon: <ProjectOutlined />,
      children: [
        {
          label: "Residential Projects",
          key: "11",
          icon: <HomeOutlined />,
        },
        {
          label: "Commercial Projects",
          key: "12",
          icon: <ShopOutlined />,
        },
        {
          label: "Land Projects",
          key: "13",
          icon: <BoxPlotOutlined />,
        },
      ],
    },
    {
      label: "Settings",
      key: "14.1",
      icon: <SettingOutlined />,
      children: [
        {
          label: "Inbound Property",
          key: "14",
          icon: <InboxOutlined />,
        },
        {
          label: "Areas",
          key: "15",
          icon: <FullscreenExitOutlined />,
        },
        {
          label: "Users",
          key: "16",
          icon: <UserAddOutlined />,
        },
        {
          label: "Activity",
          key: "17",
          icon: <FileTextOutlined />,
        },
        {
          label: "Inquiries",
          key: "24",
          icon: <MailOutlined />,
        },
      ],
    },
  ];

  const hasPermission = (resource, action) => {
    if (currentUser?.role === "Admin") return true;
    if (
      resource === "tasks" ||
      resource === "inquiries" ||
      resource === "images" ||
      resource === "birthday" ||
      resource === "interesteds" ||
      resource === "site_visit_details"
    )
      return true;
    if (
      (resource === "projects" || resource.startsWith("projects_")) &&
      (action === "index" || action === "show")
    )
      return true;
    if (resource === "areas" && action === "index") return true;
    if (!currentUser?.permissions) return false;
    return currentUser.permissions.some(
      (p) => p.resource === resource && p.action === action,
    );
  };

  const filteredMenuItems = menuItems
    .filter((item) => !item.adminOnly || currentUser?.role === "Admin")
    .map(({ adminOnly, ...item }) => {
      let disabled = false;
      if (currentUser?.role !== "Admin") {
        if (item.label === "Leads") {
          disabled = !hasPermission("leads", "index");
        } else if (item.label === "Clients") {
          disabled = !hasPermission("clients", "index");
        } else if (item.label === "Developers") {
          disabled = !hasPermission("clients_developer", "index");
        } else if (item.label === "Properties") {
          const propertyKeys = [
            "properties_bunglow",
            "properties_flat",
            "properties_rent_residential",
            "properties_commercial",
            "properties_rent_commercial",
            "properties_land",
            "properties_na_agriculture",
          ];
          disabled = !propertyKeys.some((key) => hasPermission(key, "index"));
        } else if (item.label === "Builder") {
          const builderKeys = [
            "properties_bunglow_developer",
            "properties_flat_developer",
            "properties_commercial_developer",
            "properties_land_developer",
          ];
          disabled = !builderKeys.some((key) => hasPermission(key, "index"));
        } else if (item.label === "Projects") {
          disabled = !hasPermission("projects", "index");
        }
      }

      return {
        ...item,
        disabled,
        children: item.children
          ?.filter(
            (child) =>
              !(child.label === "Users" && currentUser?.role === "Employee"),
          )
          ?.map((child) => {
            let childDisabled = false;
            if (currentUser?.role !== "Admin") {
              if (child.label === "Inquiries") {
                childDisabled = !hasPermission("inquiries", "index");
              } else if (child.label === "Areas") {
                childDisabled = !hasPermission("areas", "index");
              } else if (item.label === "Properties") {
                const mapping = {
                  Bunglow: "properties_bunglow",
                  Flat: "properties_flat",
                  "Rent Residential": "properties_rent_residential",
                  Commercial: "properties_commercial",
                  "Rent Commercial": "properties_rent_commercial",
                  Land: "properties_land",
                  "NA/Agriculture": "properties_na_agriculture",
                };
                const permKey = mapping[child.label];
                if (permKey) {
                  childDisabled = !hasPermission(permKey, "index");
                }
              } else if (item.label === "Builder") {
                const mapping = {
                  Bunglow: "properties_bunglow_developer",
                  Flat: "properties_flat_developer",
                  Commercial: "properties_commercial_developer",
                  Land: "properties_land_developer",
                };
                const permKey = mapping[child.label];
                if (permKey) {
                  childDisabled = !hasPermission(permKey, "index");
                }
              }
            }
            return {
              ...child,
              disabled: childDisabled,
            };
          }),
      };
    });

  const handleResize = useCallback(
    debounce(() => {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== size.width || newHeight !== size.height) {
        setSize({ width: newWidth, height: newHeight });
      }
    }, 200),
    [size],
  );
  useResizeObserver(handleResize);

  const [notificationTarget, setNotificationTarget] = useState(null);

  const handleNotificationNavigate = (data) => {
    if (!data) return;
    const screen = data.screen || data.type;
    const targetPreLeadId = data.pre_lead_id || data.preLeadId;
    const targetLeadId = data.lead_id || data.leadId;
    const targetTaskId = data.task_id || data.taskId;

    if (
      screen === "CloudLeads" ||
      targetPreLeadId ||
      screen === "pre_lead_assigned" ||
      screen === "pre_lead_transferred" ||
      screen === "new_pre_lead" ||
      screen === "pre_lead_dismissed"
    ) {
      setNotificationTarget({ type: "pre_lead", id: targetPreLeadId });
      setItemKey("26");
    } else if (
      screen === "LeadDetails" ||
      targetLeadId ||
      screen === "lead_transferred"
    ) {
      setNotificationTarget({ type: "lead", id: targetLeadId });
      setItemKey("10");
    } else if (
      screen === "Dashboard" ||
      targetTaskId ||
      screen === "task_inactivity_reminder"
    ) {
      setNotificationTarget({ type: "task", id: targetTaskId });
      setItemKey("1");
    }
  };

  const userInitial = currentUser?.first_name
    ? currentUser.first_name.charAt(0).toUpperCase()
    : currentUser?.name
    ? currentUser.name.charAt(0).toUpperCase()
    : currentUser?.email
    ? currentUser.email.charAt(0).toUpperCase()
    : null;

  return (
    <Layout ref={ref} style={{ minHeight: "100vh", maxHeight: "100vh", overflow: "hidden" }}>
      <Affix offsetTop={0} style={{ position: "sticky", zIndex: 10 }}>
        <Sider
          width={200}
          style={{ height: "100vh" }}
          className="sider customeScrollbar"
          breakpoint="lg"
          collapsedWidth="0"
          collapsed={collapsed}
          onCollapse={(collapsed) => setCollapsed(collapsed)}
        >
          {!collapsed && <div className="logo" />}
          <div style={{ height: "calc(100vh - 200px)", overflowY: "auto" }}>
            <Menu
              onClick={(e) => setItemKey(e.key)}
              mode="inline"
              selectedKeys={[itemKey]}
              items={filteredMenuItems}
            ></Menu>
          </div>
        </Sider>
      </Affix>
      <Layout style={{ height: "100vh", overflow: "hidden", display: "flex", flexDirection: "column" }}>
        <Affix offsetTop={0} style={{ position: "sticky", zIndex: 10 }}>
          <Header
            className="site-layout-sub-header-background"
            style={{ padding: "0 24px" }}
          >
            <div
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                height: "100%",
              }}
            >
              <NotificationBell activeTab={itemKey} onNavigate={handleNotificationNavigate} />
              <Dropdown menu={{ items }} trigger={["click"]}>
                <Avatar
                  size="large"
                  style={{
                    backgroundColor: "#8C54FF",
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    fontWeight: "600",
                    fontSize: 16,
                  }}
                >
                  {userInitial || <UserOutlined />}
                </Avatar>
              </Dropdown>
            </div>
          </Header>
        </Affix>
        <Content className="content_view" style={{ flex: 1, overflowY: "auto" }}>
          <div className="site-layout-background">
            {itemKey === "1" && <Dashboard currentUser={currentUser} />}
            {itemKey === "2" && <Clients currentUser={currentUser} />}
            {/* {itemKey === "3" && <Properties />} */}
            {itemKey === "4" && <BunglowProperties currentUser={currentUser} />}
            {itemKey === "5" && <FlatProperties currentUser={currentUser} />}
            {itemKey === "6" && (
              <RentResidentialProperties currentUser={currentUser} />
            )}
            {itemKey === "7" && (
              <CommercialProperties currentUser={currentUser} />
            )}
            {itemKey === "8" && (
              <RentCommercialProperties currentUser={currentUser} />
            )}
            {itemKey === "9" && <LandProperties currentUser={currentUser} />}
            {itemKey === "25" && (
              <AgricultureProperties currentUser={currentUser} />
            )}
            {itemKey === "10" && (
              <Leads
                {...props}
                currentUser={currentUser}
                targetId={notificationTarget?.type === "lead" ? notificationTarget.id : null}
              />
            )}
            {itemKey === "26" && (
              <CloudLeads
                currentUser={currentUser}
                targetId={
                  notificationTarget?.type === "pre_lead"
                    ? notificationTarget.id
                    : null
                }
              />
            )}
            {itemKey === "11" && <ResidentialProjects />}
            {itemKey === "12" && <CommercialProjects />}
            {itemKey === "13" && <LandProjects />}
            {itemKey === "14" && (
              <InBoundProperties currentUser={currentUser} />
            )}
            {itemKey === "15" && <Areas />}
            {itemKey === "16" && <EmployeeUsers currentUser={currentUser} />}
            {itemKey === "17" && <Activity />}
            {itemKey === "19" && (
              <BunglowDeveloperProperties
                itemKey={itemKey}
                currentUser={currentUser}
              />
            )}
            {itemKey === "20" && (
              <FlatDeveloperProperties
                itemKey={itemKey}
                currentUser={currentUser}
              />
            )}
            {itemKey === "21" && (
              <CommercialDevelporProperies
                itemKey={itemKey}
                currentUser={currentUser}
              />
            )}
            {itemKey === "22" && (
              <LandDeveloperProperties
                itemKey={itemKey}
                currentUser={currentUser}
              />
            )}
            {itemKey === "23" && (
              <Clients itemKey={itemKey} currentUser={currentUser} />
            )}
            {itemKey === "24" && (
              <Enquiries itemKey={itemKey} currentUser={currentUser} />
            )}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};
